
<router-outlet></router-outlet>
<!-- <a class="qlwapp-toggle" data-action="open" data-phone="918328579397" data-message="Hello, What would you like to get from India today?" href="https://api.whatsapp.com/send?phone=918328579397&amp;text=Hello, What would you like to get from India today?" target="_blank">
    <div class="example-button-container" style="bottom: 25px;right: 35px;position: fixed;">
        <button class="whats" mat-fab color="primary"  style="background-color: #000080;width: 60px;height: 60px;padding-bottom: 25px;">
          <mat-icon><i class="fa fa-whatsapp" style="font-size: 27px;"></i></mat-icon>
        </button>
    </div>
</a> -->
<!-- <jjva-ngx-whatsapp-button [ngx_whatsapp_phone]="phone" [ngx_whatsapp_text]="title11"></jjva-ngx-whatsapp-button> -->